module.exports = __webpack_public_path__ + "img/order_plus.7114eb11.svg";